import { ReactElement } from "react";
import ReactMarkdown from "react-markdown";

import { ReactComponent as Close } from "../../assets/icons/close.svg";

import {
  Description,
  IconContainer,
  Modal,
  Overlay,
  Relative,
  Title,
} from "./components";

export type Props = {
  readonly title: string;
  readonly description: string;
  readonly onClose: () => void;
  readonly children?: ReactElement;
};

// eslint-disable-next-line @typescript-eslint/prefer-readonly-parameter-types
const PopUp = ({
  title,
  description,
  onClose,
  children,
}: Props): ReactElement => (
  <Overlay>
    <Modal>
      <Relative>
        <IconContainer>
          <Close onClick={onClose} />
        </IconContainer>
      </Relative>
      <Title>{title}</Title>
      <Description>
        <ReactMarkdown>{description}</ReactMarkdown>
      </Description>
      {children}
    </Modal>
  </Overlay>
);

export default PopUp;
